export default __webpack_public_path__ + "static/media/github.191c4039.svg";